module.exports = __webpack_public_path__ + "static/media/icn-53-money.bdd1a648.svg";